import { render, staticRenderFns } from "./RejectDocumentModal.component.vue?vue&type=template&id=37868496"
import script from "./RejectDocumentModal.component.vue?vue&type=script&lang=js"
export * from "./RejectDocumentModal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports